import * as React from 'react';
import {Avatar, Button, Divider, Select, Table} from 'antd';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import FormattedDateTime from "@components/custom/FormattedDateTime";
import {Ticket, StatusTypeOptions, DepartmentTypeOptions} from '@models/ticket';
import TicketForm from "@components/tickets/Form";
import {PaginationDefaultParams} from "../custom/Paginator";
import TextWithTooltip from "../custom/TextWithTooltip";


type Props = {
  data: Ticket[];
  loading: boolean;
  updateRequest: (item: Ticket) => void;
  intl: intlShape.isRequired;
  currentPage: number;
  
};

const TicketsTable: React.FC<Props> = props => {
  const {data, loading, currentPage, updateRequest} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const onChangeStatus = (status, ticket_id) => {
    updateRequest({
      payload: [{
        value: status,
        path: "status",
        op: "replace",
        from: ""
      }],
      params: {
        id: ticket_id
      },
      patch: true
    })
  };
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: 'index',
      key: 'id',
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: "",
      width: 30,
      dataIndex: 'avatar',
      key: 'avatar',
      render: (user, record) => {
        return (
          <Avatar shape="circle"
                  size="small"
                  src={user && user.avatar ? user.avatar : null}
          />
        )
      }
    },
    {
      title: <FormattedMessage id="app.name" defaultMessage={`Name`}/>,
      width: 100,
      dataIndex: 'user',
      key: 'user',
      render: (user, record: any) => <span>{user?.name ? user.name + " " + user.family : ""}</span>
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
      width: 100,
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: <FormattedMessage id="app.body" defaultMessage={`Body`}/>,
      width: 100,
      dataIndex: 'body',
      key: 'body',
      render: (text) => <TextWithTooltip text={text || ""}/>
    },
    {
      title: <FormattedMessage id="app.response" defaultMessage={`Response`}/>,
      width: 100,
      dataIndex: 'response',
      key: 'response',
      render: (text) => <TextWithTooltip text={text || ""}/>
    },
    {
      title: <FormattedMessage id="app.creation_date" defaultMessage={`Creation Date`}/>,
      width: 100,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text, record) => <FormattedDateTime date={text}/>
    },
    {
      title: <FormattedMessage id="app.close_time" defaultMessage={`Close Time`}/>,
      width: 100,
      dataIndex: 'close_time',
      key: 'close_time',
      render: (text, record) => <FormattedDateTime date={text}/>
    },
    {
      title: <FormattedMessage id="app.department" defaultMessage={`Department`}/>,
      key: 'department',
      width: 70,
      dataIndex: 'department',
      render: type => {
        const obj = DepartmentTypeOptions.find(item => item.value == type);
        return obj ? obj.label : type;
      }
    },
    {
      title: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
      key: 'status',
      width: 30,
      dataIndex: 'status',
      render: (status, record) => (
        <Select value={record.status} className={status}
                onChange={(status) => onChangeStatus(status, record.id)}>
          {StatusTypeOptions.map((opt, index) => (
            <Select.Option key={`${record.id}_${index}`} value={opt.value}
                           recorddata={record}>{opt.label}</Select.Option>
          ))}
        </Select>
      )
    },
    
    {
      title: '',
      key: 'actions',
      width: 20,
      dataIndex: 'actions',
      render: (text, record) => (
        <span>
                 <TicketForm ticket={record} toggleButton={(
                   <Button type="link" size={`small`}>
                     <FormattedMessage id="app.answer" defaultMessage={`Answer`}/>
                   </Button>
                 )}/>
              </span>
      )
    }
  ];
  
  return (
    <Table columns={columns}
           loading={loading}
           pagination={false}
           dataSource={data}
           rowKey='id'/>
  )
  
};

export default injectIntl(TicketsTable)